<template>
  <div>
    <Field
      :ref="iModel.password"
      v-slot="{ errors, field, value }"
      v-model="_password"
      tag="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@PASSWORD'))"
      :rules="{ required: true, min: 8 }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :type="isPwd ? 'password' : 'text'"
        :label="$t('ETAB.FORMS.LABELS.@PASSWORD')"
        :name="iModel.password"
        :hint="$t('ETAB.FORMS.LABELS.@PASSWORD_HELPER')"
        :error="errors.length > 0"
        :error-message="errors[0]"
      >
        <template #append>
          <QIcon :name="isPwd ? 'icon-f-eye' : 'icon-f-eye-off'" class="cursor-pointer" @click="isPwd = !isPwd" />
        </template>
      </QInput>
    </Field>
  </div>
</template>

<script>
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      password: { type: String, default: null },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:password"],
    data() {
      return {
        isPwd: true,
      };
    },
    computed: {
      _password: {
        get() {
          return this.password;
        },
        set(value) {
          this.$emit("update:password", value);
        },
      },
    },
  };
</script>
